//GraLay.ts =================================================
import "../Util/Prototypes";

import * as GraLay from "./GraLay";
import * as Util from "./Util";

import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";

//Set layer id's for creation. First layer will be on top.
export const id_list: string[] = [
   "temp",
   "measureLabels",
   "measure",
   "agUseLabels",
   "agUse",
   "sketch",
   "hoverPoint", "hoverLine", "hoverPoly",
   "identifyPoint", "identifyLine", "identifyPoly",
   "selectedPoint", "selectedHoverPoint", "selectedLine", "selectedHoverLine", "selectedPoly", "selectedHoverPoly",
   "appPnt", "appPntHighlight", "appPoly",
];

export let temp: __esri.GraphicsLayer;
export let measureLabels: __esri.GraphicsLayer;
export let measure: __esri.GraphicsLayer;
export let agUseLabels: __esri.GraphicsLayer;
export let agUse: __esri.GraphicsLayer;
export let sketch: __esri.GraphicsLayer;

export let hoverPoint: __esri.GraphicsLayer;
export let hoverLine: __esri.GraphicsLayer;
export let hoverPoly: __esri.GraphicsLayer;

export let identifyPoint: __esri.GraphicsLayer;
export let identifyLine: __esri.GraphicsLayer;
export let identifyPoly: __esri.GraphicsLayer;

export let selectedPoint: __esri.GraphicsLayer;
export let selectedLine: __esri.GraphicsLayer;
export let selectedPoly: __esri.GraphicsLayer;

export let selectedHoverPoint: __esri.GraphicsLayer;
export let selectedHoverLine: __esri.GraphicsLayer;
export let selectedHoverPoly: __esri.GraphicsLayer;

export let appPnt: __esri.GraphicsLayer;
export let appPntHighlight: __esri.GraphicsLayer;
export let appPoly: __esri.GraphicsLayer;

//Load graphics layers.
export function loadGraphicsLayers(): __esri.GraphicsLayer[] {
   let i: number;
   let id: string;
   let layerName: string;
   let graphicLayer: __esri.GraphicsLayer;
   const graLays: __esri.GraphicsLayer[] = [];

   Util.logMsg('Creating graphics layers.');

   for (i = id_list.length - 1; i >= 0; i--) {
      layerName = id_list[i];
      id = layerName + "_GraLay";
      graphicLayer = new GraphicsLayer({ id: id, title: id, listMode: "hide" });
      graLays.Add(graphicLayer);

      switch (layerName) {
         case "temp":
            temp = graphicLayer; break;

         case "measureLabels":
            measureLabels = graphicLayer; break;

         case "measure":
            measure = graphicLayer; break;

         case "agUseLabels":
            agUseLabels = graphicLayer; break;

         case "agUse":
            agUse = graphicLayer; break;

         case "sketch":
            sketch = graphicLayer; break;

         case "hoverPoint":
            hoverPoint = graphicLayer; break;

         case "hoverLine":
            hoverLine = graphicLayer; break;

         case "hoverPoly":
            hoverPoly = graphicLayer; break;

         case "identifyPoint":
            identifyPoint = graphicLayer; break;

         case "identifyLine":
            identifyLine = graphicLayer; break;

         case "identifyPoly":
            identifyPoly = graphicLayer; break;

         case "selectedPoint":
            selectedPoint = graphicLayer; break;

         case "selectedHoverPoint":
            selectedHoverPoint = graphicLayer; break;

         case "selectedLine":
            selectedLine = graphicLayer; break;

         case "selectedHoverLine":
            selectedHoverLine = graphicLayer; break;

         case "selectedPoly":
            selectedPoly = graphicLayer; break;

         case "selectedHoverPoly":
            selectedHoverPoly = graphicLayer; break;

         case "appPnt":
            appPnt = graphicLayer; break;

         case "appPntHighlight":
            appPntHighlight = graphicLayer; break;

         case "appPoly":
            appPoly = graphicLayer; break;
      }
   }

   return graLays;
}

//Clear generic hover graphic highlighting.
export function clearHoverGraphics() {
   GraLay.hoverPoint.removeAll();
   GraLay.hoverLine.removeAll();
   GraLay.hoverPoly.removeAll();
}

//Clear all identify graphic highlighting.
export function clearIdentifyHighlightGraphics() {
   GraLay.identifyPoint.removeAll();
   GraLay.identifyLine.removeAll();
   GraLay.identifyPoly.removeAll();
}

//Clear all selection graphic highlighting.
export function clearSelectHighlightGraphics() {
   GraLay.selectedPoint.removeAll();
   GraLay.selectedLine.removeAll();
   GraLay.selectedPoly.removeAll();
}

//Clear select hover graphics.
export function clearSelectHoverGraphics() {
   GraLay.selectedHoverPoint.removeAll();
   GraLay.selectedHoverLine.removeAll();
   GraLay.selectedHoverPoly.removeAll();
}

export function clearAppGraphics() {
   //GraLay.appPoly.clear();
   //GraLay.appLine.clear();
   //GraLay.appPnt.clear();
   //GraLay.appText.clear();

   //GraLay.flag.clear();
}
